// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2eH_D","title":"ClientReferral_title__3LvVQ","itemText":"ClientReferral_itemText__WewG9"};